var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditSquare = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_616_655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_616_655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21.0001C4.45 21.0001 3.97917 20.8043 3.5875 20.4126C3.19583 20.021 3 19.5501 3 19.0001V5.00013C3 4.45013 3.19583 3.97929 3.5875 3.58763C3.97917 3.19596 4.45 3.00013 5 3.00013H13.925L11.925 5.00013H5V19.0001H19V12.0501L21 10.0501V19.0001C21 19.5501 20.8042 20.021 20.4125 20.4126C20.0208 20.8043 19.55 21.0001 19 21.0001H5ZM9 15.0001V10.7501L18.175 1.57513C18.375 1.37513 18.6 1.22513 18.85 1.12513C19.1 1.02513 19.35 0.975128 19.6 0.975128C19.8667 0.975128 20.1208 1.02513 20.3625 1.12513C20.6042 1.22513 20.825 1.37513 21.025 1.57513L22.425 3.00013C22.6083 3.20013 22.75 3.42096 22.85 3.66263C22.95 3.90429 23 4.15013 23 4.40013C23 4.65013 22.9542 4.89596 22.8625 5.13763C22.7708 5.37929 22.625 5.60013 22.425 5.80013L13.25 15.0001H9ZM11 13.0001H12.4L18.2 7.20013L17.5 6.50013L16.775 5.80013L11 11.5751V13.0001Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit_square.56ce46ae.svg";
export { ForwardRef as ReactComponent };